const BlankPage = () => {
  return <h1>web-app-automation</h1>
}

export default BlankPage
